export const DEFAULT_CONFIG = {
  billable: false,
  applyJIRAIssueLabels: false,
  mapProjectsForAll: false,
  addTagSameAsEpicName: false,
  addTagSameAsIssueType: false,
  roundTime: false,
  jiraTimeZone: '',
};
